<palantir-modal [formGroup]="assetsTreeFilterForm">
  <palantir-toolbar palantir-modal-header>
    <palantir-toolbar-main>
      <palantir-text type="title" size="lg" palantir-toolbar-main-title>
        {{ 'ASSETS_TREE.FILTERS.TITLE' | translate }}
      </palantir-text>
    </palantir-toolbar-main>

    <palantir-toolbar-suffix>
      @if (assetsTreeFilterService.isFiltering()) {
        <palantir-button
          (click)="clearFiltersEvent()"
          theme="outline"
          size="xs"
          layout="prefix"
          variant="neutral"
          icon="filter-off-filled"
        >
          {{ 'ASSETS_TREE.FILTERS.CLEAR' | translate }}
        </palantir-button>
      }

      <palantir-button
        theme="outline"
        size="xs"
        layout="icon"
        variant="neutral"
        icon="close-outline"
        [palantirTooltip]="'ASSETS_TREE.FILTERS.CLOSE' | translate"
        (click)="close()"
      ></palantir-button>
    </palantir-toolbar-suffix>
  </palantir-toolbar>

  <palantir-modal-content>
    <ng-scrollbar [visibility]="'hover'" autoHeightDisabled="false">
      <div class="w-full h-full p-6 flex flex-col gap-3">
        <palantir-accordion [title]="'ASSETS_TREE.FILTERS.INPUTS.PERIOD.TITLE' | translate" [open]="true">
          <palantir-input
            [control]="assetsTreeFilterForm.get('warrantyStartDateLte')"
            label="{{ 'ASSETS_TREE.FILTERS.INPUTS.PERIOD.FROM' | translate }}"
            suffix="calendar-outline"
          >
            <input
              type="date"
              max="{{ assetsTreeFilterForm.get('warrantyStartDateLte')?.value }}"
              placeholder="{{ 'ASSETS_TREE.FILTERS.INPUTS.PERIOD.PLACEHOLDER' | translate }}"
              formControlName="warrantyStartDateLte"
            />
          </palantir-input>

          <palantir-input
            [control]="assetsTreeFilterForm.get('warrantyEndDateGte')"
            label="{{ 'ASSETS_TREE.FILTERS.INPUTS.PERIOD.UNTIL' | translate }}"
            suffix="calendar-outline"
          >
            <input
              type="date"
              min="{{ assetsTreeFilterForm.get('warrantyEndDateGte')?.value }}"
              placeholder="{{ 'ASSETS_TREE.FILTERS.INPUTS.PERIOD.PLACEHOLDER' | translate }}"
              formControlName="warrantyEndDateGte"
            />

            @if (assetsTreeFilterForm.hasError('dateRangeInvalid')) {
              <palantir-input-error>
                @if (assetsTreeFilterForm.hasError('dateRangeInvalid')) {
                  <palantir-text type="negative">
                    {{ 'ASSETS_TREE.FILTERS.INPUTS.PERIOD.ERRORS.MIN' | translate }}
                  </palantir-text>
                }
              </palantir-input-error>
            }
          </palantir-input>
        </palantir-accordion>

        <palantir-accordion [title]="'ASSETS_TREE.FILTERS.INPUTS.STATUS.TITLE' | translate" [open]="true">
          <div class="flex flex-row justify-start items-center gap-2 mb-5">
            <palantir-checkbox
              [label]="'ASSETS_TREE.FILTERS.INPUTS.STATUS.SELECT_ALL' | translate"
              [attr.aria-selected]="isAllSelected()"
              (click)="toggleAllSelection()"
            ></palantir-checkbox>
          </div>
          <palantir-content class="w-full">
            @for (status of warrantyStatuses; track $index) {
              <div class="flex flex-row justify-between items-center b-2">
                <button
                  type="button"
                  class="flex items-center gap-1 p-3 hover:bg-[#F5F8FE] active:bg-[#E5EEFF] bg-transparent rounded-lg cursor-pointer border-none w-full"
                  (click)="toggleSelection(status)"
                >
                  <div class="flex items-center gap-2">
                    <div
                      class="w-2 h-2 rounded-full"
                      [ngClass]="{
                        'bg-green-600': status === WarrantyStatuses.ACTIVE,
                        'bg-red-600': status === WarrantyStatuses.EXPIRED,
                        'bg-yellow-600': status === WarrantyStatuses.EXTENDED,
                        'bg-blue-600': status === WarrantyStatuses.FUTURE,
                      }"
                    ></div>
                    <palantir-text type="text">
                      {{ 'ASSETS_TREE.FILTERS.INPUTS.STATUS.OPTIONS.' + status.toUpperCase() | translate }}
                    </palantir-text>
                  </div>
                  <palantir-checkbox
                    class="ml-auto"
                    [attr.aria-selected]="warrantyStatusIn().includes(status)"
                    [attr.invert]="true"
                  ></palantir-checkbox>
                </button>
              </div>
            }
          </palantir-content>
        </palantir-accordion>
      </div>
    </ng-scrollbar>
  </palantir-modal-content>
</palantir-modal>
